import { APPLICATION_MODULE_KEY, type EnabledModulesState } from '@/types/applicationModule';

export const ENABLED_MODULES_STORAGE_KEY = 'zoofizjo_enabled_modules';

export const DEFAULT_ENABLED_MODULES: EnabledModulesState = {
  [APPLICATION_MODULE_KEY.dashboard]: true,
  [APPLICATION_MODULE_KEY.calendar]: true,
  [APPLICATION_MODULE_KEY.patients]: true,
  [APPLICATION_MODULE_KEY.clients]: true,
  [APPLICATION_MODULE_KEY.settings]: true,
  [APPLICATION_MODULE_KEY.consultation]: true,
  [APPLICATION_MODULE_KEY.notes]: true,
  [APPLICATION_MODULE_KEY.plans]: true,
  [APPLICATION_MODULE_KEY.library]: true,
  [APPLICATION_MODULE_KEY.devices]: true,
  [APPLICATION_MODULE_KEY.files]: true,
  [APPLICATION_MODULE_KEY.gdpr]: true,
  [APPLICATION_MODULE_KEY.exercises]: true,
  [APPLICATION_MODULE_KEY.reports]: false,
  [APPLICATION_MODULE_KEY.googleSync]: false,
};

export const CORE_MODULE_KEYS = [
  APPLICATION_MODULE_KEY.dashboard,
  APPLICATION_MODULE_KEY.calendar,
  APPLICATION_MODULE_KEY.patients,
  APPLICATION_MODULE_KEY.clients,
  APPLICATION_MODULE_KEY.settings,
] as const;

export const COMING_SOON_MODULE_KEYS = [
  APPLICATION_MODULE_KEY.reports,
  APPLICATION_MODULE_KEY.googleSync,
] as const;
